const servicesData = [
  {
    title: "ARCHITECTURAL BIM",
    iconClass: "BIM Architecture_page-0001",
    description: `Architectural BIM Services create precise Revit models from sketches, scans, and PDFs, including custom content and 3D rendering, aligned with client's SOW and LOD specifications.`,
    details:
      " At The Zenith Visions, we specialize in delivering cutting-edge Architectural BIM Services that redefine the way architecture meets technology. Our approach focuses on creating intelligent, data-rich 3D models that streamline the design, documentation, and execution of architectural projects, ensuring unmatched precision and efficiency can bring your vision to life.",
    cards: [
      {
        name: `ARCHITECTURAL 3D MODELING`,
        content:
          "Create precise and customizable Revit 3D BIM models in alignment with the specified Scope of Work, indicating trades to be incorporated or omitted, while meeting the necessary Level of Development (LOD) and detailed specifications such as sections, elevations, roofing, walls, doors, and other relevant components.",
        img: "../images/cards/a2b/1.jpg",
      },
      {
        name: "SCHEDULES",
        content: `I optimize architectural project management using Revit, crafting detailed schedules that enhance efficiency by organizing materials, quantities, and timelines. My expertise ensures precise documentation and seamless stakeholder coordination, tailoring schedules for informed decision-making. This elevates workflows, fostering smoother operations and communication across the project lifecycle.
          Comprehensive 3D Visualization: Explore designs in a realistic and interactive 3D environment.
          Design Coordination: Ensure seamless collaboration among architects, engineers, and contractors.
          Error Detection: Minimize construction errors through clash detection and conflict resolution.
        `,
        img: "../images/cards/a2b/2.jpg",
      },
      {
        name: "2D DRAFTING SERVICE",
        content:
          "Provide 2D CAD files in the .dwg format according to the client's specific standards, including the necessary Level of Detail, encompassing dimensions, annotations, layering, etc., as outlined in the client's standard format and Scope of Work. | Site Plan | Floor Plan | Cross Section | Elevation | Landscape | Finishing | Drawing | Working | Plan | Section Drawings | General Note | Excavation Drawing | As-Built drawings | Line Plan | Shop Drawings | Installation Drawings | Location Drawings | Location Plan |",
        img: "../images/cards/a2b/3.jpg",
      },
      {
        name: "CAD to BIM Conversion:",
        content: `
          We convert legacy 2D CAD drawings into intelligent 3D BIM models, ensuring enhanced accuracy and efficiency. This service is ideal for clients transitioning to BIM workflows or updating older projects.
          Quick Transition: Speed up the process of migrating from traditional drafting to modern BIM workflows.
          Data Enrichment: Add parametric data to existing designs for improved project insights.
          Compliance: Ensure alignment with local and international BIM standards.
          `,
        img: "../images/cards/a2b/4.jpg",
      },
      {
        name: "LOD (Level of Development) Modeling:",
        content: `
        We provide BIM models at varying Levels of Development (LOD), from conceptual design (LOD 100) to construction-ready detailing (LOD 500). This ensures that our models meet the specific requirements of every project phase.
        LOD 100: Conceptual modeling for early design stages.
        LOD 200: Schematic designs for structural elements.
        LOD 300: Detailed design for construction documentation.
        LOD 400: Fabrication-ready models for structural components.
        LOD 500: As-built models for maintenance and operations.
        Value: By using LOD-based modeling, stakeholders can make informed decisions at every stage of the project.`,
        img: "../images/cards/a2b/5.jpg",
      },
    ],
  },
  {
    title: "STRUCTURAL BIM",
    iconClass: "icon-bulb",
    description:
      "Our Structural BIM modeling services focus on creating detailed, data-rich, and 3D structural models tailored to your project requirements. Whether you need structural steel, concrete, timber, or composite designs, our expert team ensures precision in: Developing 3D models for beams, columns, slabs, foundations, trusses, and walls. Clash detection and resolution to identify and address potential conflicts. Integration of architectural and MEP systems to deliver a coordinated design. Supporting accurate quantity take-offs, schedules, and cost estimation.",
    details: `At The Zenith Visions, we specialize in delivering cutting-edge Structural BIM Services that revolutionize how structural design integrates with advanced technology. Our approach focuses on developing intelligent, data-rich 3D models that optimize the analysis, design, and documentation processes. By seamlessly integrating structural integrity with precision and efficiency, we ensure every project is executed to perfection, bringing your vision to life with unparalleled expertise.`,
    cards: [
      {
        name: "STRUCTURAL BIM Modeling",
        content: `Our Structural BIM modeling services focus on creating detailed, data-rich, and 3D structural models tailored to your project requirements. Whether you need structural steel, concrete, timber, or composite designs, our expert team ensures precision in:
        Developing 3D models for beams, columns, slabs, foundations, trusses, and walls.
        Clash detection and resolution to identify and address potential conflicts.
        Integration of architectural and MEP systems to deliver a coordinated design.
        Supporting accurate quantity take-offs, schedules, and cost estimation.
        `,
        img: "../images/cards/stru-BIM/1.jpg",
      },
      {
        name: "CONSTRUCTION DOCUMENTATION",
        content:
          "Provide .dwg format 2D CAD files meeting client specifications, ensuring precision and adherence to specified Level of Detail. Include dimensions, annotations, and layering aligned with client standards and Scope of Work. Deliverables comprise | foundation | column layout | Floor Plan | Cross Section | Elevation | framing |Finishing details | abbreviations | G.A Drawing | General notes | Plan | Section | Shop Drawings | symbols | schedules | BBS |",
        img: "../images/cards/stru-BIM/2.jpg",
      },
      {
        name: "REBAR DETAIL",
        content:
          "Comprehensive sketches depicting the bar and steel in | beams | columns | joists | foundation | bolted connection | staircases | lintels | roof | structures | shelf angles | bearing plates | frames | wall partition supports | and workshop drawings.",
        img: "../images/cards/stru-BIM/3.jpg",
      },
      {
        name: "STRUCTURAL BIM Modeling",
        content: `Our Structural BIM modeling services focus on creating detailed, data-rich, and 3D structural models tailored to your project requirements. Whether you need structural steel, concrete, timber, or composite designs, our expert team ensures precision in:
        Developing 3D models for beams, columns, slabs, foundations, trusses, and walls.
        Clash detection and resolution to identify and address potential conflicts.
        Integration of architectural and MEP systems to deliver a coordinated design.
        Supporting accurate quantity take-offs, schedules, and cost estimation.
        `,
        img: "../images/cards/stru-BIM/4.jpg",
      },
      {
        name: "LOD (Level of Development) Modeling",
        content: `
        We provide LOD modeling ranging from LOD 100 to LOD 500, ensuring clarity and precision at every stage of the project lifecycle:
        LOD 100: Conceptual modeling for early design stages.
        LOD 200: Schematic designs for structural elements.
        LOD 300: Detailed design for construction documentation.
        LOD 400: Fabrication-ready models for structural components.
        LOD 500: As-built models for maintenance and operations.
        Value: By using LOD-based modeling, stakeholders can make informed decisions at every stage of the project.
        `,
        img: "../images/cards/stru-BIM/5.jpg",
      },
    ],
  },
  {
    title: "MEP BIM",
    iconClass: "icon-data",
    description:
      "At The Zenith Visions, we excel in providing state-of-the-art MEP BIM Services, revolutionizing how mechanical, electrical, and plumbing systems integrate with technology. Our expertise lies in creating intelligent, data-enriched 3D models that optimize design coordination, documentation, and execution processes. With a focus on precision and efficiency, we ensure seamless integration of MEP systems, bringing your vision to reality with unparalleled accuracy and innovation.",
    details:
      "We deliver accurate and clash-free MEP models that integrate seamlessly with architectural and structural designs. Our expertise includes:<br/>Mechanical Systems: HVAC layouts, ductwork modeling, and airflow simulations.<br/>    Electrical Systems: Lighting layouts, power distribution, conduit routing, and cable tray modeling.<br/>    Plumbing Systems: Piping for water supply, drainage, and gas systems.<br/>    Fire Protection Systems: Sprinkler layouts and smoke exhaust systems.",
    cards: [
      {
        name: "CLASH REPORT GENERATION",
        content:
          "Create a dashboard for clash reporting that encompasses both soft and hard clashes. This dashboard should display the ongoing progress made over time, specifically tailored for a gatekeeper meeting attended by MEP engineers, architects, general contractors, designers, and building owners.",
        img: "../images/cards/mep/1.jpg",
      },
      {
        name: "SOFT AND HARD CLASHES",
        content:
          "Detect and resolve both soft and hard conflicts within every discipline or trade that remained unnoticed during the separate design phases of architectural, structural, mechanical, electrical, and plumbing elements.",
        img: "../images/cards/mep/2.jpg",
      },
      {
        name: "MEP BIM Modeling:",
        content: `
        We deliver accurate and clash-free MEP models that integrate seamlessly with architectural and structural designs. Our expertise includes:
        Mechanical Systems: HVAC layouts, ductwork modeling, and airflow simulations.
        Electrical Systems: Lighting layouts, power distribution, conduit routing, and cable tray modeling.
        Plumbing Systems: Piping for water supply, drainage, and gas systems.
        Fire Protection Systems: Sprinkler layouts and smoke exhaust systems.        
        `,
        img: "../images/cards/mep/3.jpg",
      },

      {
        name: "LOD (Level of Development) Modeling:",
        content: `We provide BIM models at varying Levels of Development (LOD), from conceptual design (LOD 100) to construction-ready detailing (LOD 500). This ensures that our models meet the specific requirements of every project phase.
          LOD 100: Conceptual modeling for early design stages.
          LOD 200: Schematic designs for structural elements.
          LOD 300: Detailed design for construction documentation.
          LOD 400: Fabrication-ready models for structural components.
          LOD 500: As-built models for maintenance and operations.
          Value: By using LOD-based modeling, stakeholders can make informed decisions at every stage of the project.
          `,
        img: "../images/cards/mep/4.jpg",
      },

      {
        name: "CAD to BIM Conversion:",
        content: `We convert legacy 2D CAD drawings into intelligent 3D BIM models, ensuring enhanced accuracy and efficiency. This service is ideal for clients transitioning to BIM workflows or updating older projects.
          Quick Transition: Speed up the process of migrating from traditional drafting to modern BIM workflows.
          Data Enrichment: Add parametric data to existing designs for improved project insights.
          Compliance: Ensure alignment with local and international BIM standards.
          `,
        img: "../images/cards/mep/5.jpg",
      },
    ],
  },
  {
    title: "DRAFTING SERVICE",
    iconClass: "icon-data",
    description:
      "At The Zenith Visions, we pride ourselves on delivering precise and high-quality drafting services tailored to meet the needs of architects, engineers, contractors, and designers. Whether you need detailed CAD drafting, permit set documentation, or interior design documentation, our team of experts is committed to exceeding expectations. Here's an in-depth look at our drafting services:",
    details: `CAD drafting forms the backbone of modern construction and design workflows. Our team specializes in creating highly accurate and detailed CAD drawings to bring your visions to life.
    Architectural CAD Drafting: Floor plans, elevations, sections, and roof plans tailored to your design specifications.
    Structural CAD Drafting: Reinforcement details, framing plans, and structural layouts.
    Mechanical, Electrical, and Plumbing (MEP) CAD Drafting: Detailed schematics for HVAC, electrical, and plumbing systems.
    PDF/Hand Sketch to CAD: Transform rough sketches or existing PDFs into precise, editable CAD files.
    As-Built Drawings: Reflecting the exact specifications of completed structures for future reference.
    `,
    cards: [
      {
        name: "CLASH REPORT GENERATION",
        content:
          "Create a dashboard for clash reporting that encompasses both soft and hard clashes. This dashboard should display the ongoing progress made over time, specifically tailored for a gatekeeper meeting attended by MEP engineers, architects, general contractors, designers, and building owners.",
        img: "../images/cards/drafting/1.jpg",
      },
      {
        name: "SOFT AND HARD CLASHES",
        content:
          "Detect and resolve both soft and hard conflicts within every discipline or trade that remained unnoticed during the separate design phases of architectural, structural, mechanical, electrical, and plumbing elements.",
        img: "../images/cards/drafting/2.jpg",
      },
      {
        name: "CAD Drafting Services",
        content: `CAD drafting forms the backbone of modern construction and design workflows. Our team specializes in creating highly accurate and detailed CAD drawings to bring your visions to life.
        Architectural CAD Drafting: Floor plans, elevations, sections, and roof plans tailored to your design specifications.
        Structural CAD Drafting: Reinforcement details, framing plans, and structural layouts.
        Mechanical, Electrical, and Plumbing (MEP) CAD Drafting: Detailed schematics for HVAC, electrical, and plumbing systems.
        PDF/Hand Sketch to CAD: Transform rough sketches or existing PDFs into precise, editable CAD files.
        As-Built Drawings: Reflecting the exact specifications of completed structures for future reference.
        `,
        img: "../images/cards/drafting/3.jpg",
      },
      {
        name: "Permit Set Documentation",
        content: `Obtaining construction permits requires thorough and code-compliant documentation. We simplify this process by delivering high-quality permit sets that meet all regulatory requirements.
        Code Compliance: We ensure your drawings meet local building codes and zoning regulations.
        Site Plans: Detailed layouts highlighting boundaries, utilities, and environmental considerations.
        Elevation and Section Views: Highlighting key structural and design elements for approval.
        Detailed Annotations: Clear labels and dimensions to avoid ambiguity during reviews.
        Revisions and Resubmissions: Fast turnaround for revisions as per authority feedback
        `,
        img: "../images/cards/drafting/4.jpg",
      },
      {
        name: "Interior Design Documentation",
        content: `Interior design is where creativity meets technical precision. Our documentation services ensure that your design concepts translate seamlessly into buildable plans.
        Detailed Floor Plans: Highlight furniture layouts, room dimensions, and traffic flow.
        Reflected Ceiling Plans (RCP): For lighting, HVAC, and ceiling design coordination.
        Material and Finish Schedules: Specifying colors, textures, and materials for every surface.
        Custom Millwork and Joinery Details: Accurate shop drawings for cabinetry and furniture.
        3D Interior Models and Visualizations: Offering a realistic view of your designs before implementation.
        `,
        img: "../images/cards/drafting/5.jpg",
      },
    ],
  },
  {
    title: "INTERIOR DOCUMENTATION",
    iconClass: "icon-data",
    description:
      "Interior documentation is a critical part of the design and construction process, ensuring accurate translation of design intent into executable plans. At The Zenith Visions, we specialize in delivering comprehensive interior documentation services that cater to the highest standards of quality and precision.",
    details: `Building Information Modeling (BIM) for interiors integrates 3D modeling with data-rich documentation to create highly detailed and efficient design plans
    3D interior models using Revit, capturing intricate design elements like lighting, furniture, and material finishes.
    Clash detection for seamless integration of architectural, structural, and MEP components.
    As-built documentation for existing spaces, ensuring accurate renovation plans.
    Comprehensive schedules for materials, fixtures, and equipment.
    `,
    cards: [
      {
        name: "ARCHITECTURE",
        content:
          "Furniture | Foundation | Door | Window | Casework | Railing | Entourage | Ceiling | Stairs | | Bathroom | Bedroom | Kitchen & Dining |",
        img: "../images/cards/internal-doc/1.jpg",
      },
      {
        name: "STRUCTURE",
        content:
          "Column | Steel Section | Structural Steel sections – Base plates, Gusset plates | Beam Section | Stiffener | Truss | Column | Steel Section | Structural Connections |",
        img: "../images/cards/internal-doc/2.jpg",
      },
      {
        name: "BIM Interior Documentation",
        content: `Building Information Modeling (BIM) for interiors integrates 3D modeling with data-rich documentation to create highly detailed and efficient design plans
        3D interior models using Revit, capturing intricate design elements like lighting, furniture, and material finishes.
        Clash detection for seamless integration of architectural, structural, and MEP components.
        As-built documentation for existing spaces, ensuring accurate renovation plans.
        Comprehensive schedules for materials, fixtures, and equipment.
        `,
        img: "../images/cards/internal-doc/3.jpg",
      },
      {
        name: "Interior Elevations",
        content: `Interior elevations provide a clear, scaled depiction of vertical surfaces, detailing elements such as wall finishes, cabinetry, shelving, fixtures, and fittings.
        Scaled drawings showcasing wall treatments, dimensions, and material specifications.
        Precise representations of windows, doors, moldings, and built-ins.
        Room-specific elevation drawings, such as kitchens, bathrooms, and living areas, to aid in installation and visualization.`,
        img: "../images/cards/internal-doc/4.jpg",
      },
      {
        name: "Joinery Details",
        content: `Joinery details are essential for custom furniture and built-in elements, ensuring precision in fabrication and assembly.
        Detailed drawings for cabinetry, millwork, and bespoke furniture.
        Specifications for joints, materials, and finishes.
        Solutions for space optimization, functionality, and aesthetics.`,
        img: "../images/cards/internal-doc/5.jpg",
      },
    ],
  },
  {
    title: "SCAN TO BIM",
    iconClass: "icon-layers2",
    description: `Scan to BIM involves converting point cloud data obtained through 3D laser scanning or LiDAR technology into accurate, information-rich Building Information Models (BIM). These models capture the as-built conditions of a structure or site, providing detailed and precise data for architects, engineers, and contractors. We offer a comprehensive range of services in Scan to BIM, ensuring unparalleled accuracy, efficiency, and adherence to project requirements:`,
    details: `Scan to BIM involves converting point cloud data obtained through 3D laser scanning or LiDAR technology into accurate, information-rich Building Information Models (BIM). These models capture the as-built conditions of a structure or site, providing detailed and precise data for architects, engineers, and contractors.
    Point Cloud to 3D BIM Modeling: Transform raw point cloud data into intelligent 3D models using software like Revit, ArchiCAD, and AutoCAD. The models include architectural, structural, and MEP components.
    Topography Modeling: Generate accurate terrain and landscape models for site analysis and design planning.
    Architectural Modeling: Convert scan data into detailed 3D architectural models, including walls, doors, windows, and finishes.`,
    cards: [
      {
        name: "SCAN TO REVIT ARCHITECTURE",
        content:
          "I transform the accurate data obtained from laser scanning into a detailed Level of Development (LOD) 500 3D Building Information Modeling (BIM) model that contains valuable information for professional building design and maintenance purposes.",
        img: "../images/cards/s2b/1.jpg",
      },
      {
        name: "SCAN TO REVIT MEP",
        content:
          "I assist in generating Revit models for mechanical, electrical, and plumbing systems based on point cloud data, specifically for renovations in commercial and industrial structures",
        img: "../images/cards/s2b/2.jpg",
      },
      {
        name: "SCAN TO BIM SERVICES",
        content: `Scan to BIM involves converting point cloud data obtained through 3D laser scanning or LiDAR technology into accurate, information-rich Building Information Models (BIM). These models capture the as-built conditions of a structure or site, providing detailed and precise data for architects, engineers, and contractors.
        Point Cloud to 3D BIM Modeling: Transform raw point cloud data into intelligent 3D models using software like Revit, ArchiCAD, and AutoCAD. The models include architectural, structural, and MEP components.
        Topography Modeling: Generate accurate terrain and landscape models for site analysis and design planning.
        Architectural Modeling: Convert scan data into detailed 3D architectural models, including walls, doors, windows, and finishes.
        Structural Modeling: Capture the structural integrity of buildings by creating detailed models of beams, columns, trusses, and load-bearing elements.
        MEP (Mechanical, Electrical, Plumbing) Modeling: Generate precise MEP models to identify and resolve potential clashes during renovation or construction.
        Clash Detection and Coordination: Analyze scanned data to identify potential clashes in design and ensure seamless integration between architectural, structural, and MEP models.`,
        img: "../images/cards/s2b/3.jpg",
      },
      {
        name: "LOD (Level of Development) Modeling:",
        content: `We provide BIM models at varying Levels of Development (LOD), from conceptual design (LOD 100) to construction-ready detailing (LOD 500). This ensures that our models meet the specific requirements of every project phase.
        LOD 100: Conceptual modeling for early design stages.
        LOD 200: Schematic designs for structural elements.
        LOD 300: Detailed design for construction documentation.
        LOD 400: Fabrication-ready models for structural components.
        LOD 500: As-built models for maintenance and operations.
        Value: By using LOD-based modeling, stakeholders can make informed decisions at every stage of the project.
        `,
        img: "../images/cards/s2b/4.jpg",
      },
      {
        name: "AS-BUILT MODELING:",
        content: `As-built models are digital representations of a building or structure as it exists post-construction. These models are developed using scan data and are used for renovations, retrofitting, and facility management.
        Accurate As-Built Documentation: Deliver precise 2D drawings and 3D models that reflect the current state of a building. These include floor plans, elevations, and sections.
        Facility Management Integration: Incorporate metadata and functional details into the model to assist facility managers in maintenance and operational tasks.
        Renovation and Retrofit Models: Create models that help in planning and executing renovation or retrofit projects with minimal disruption.
        Compliance and Permit Models: Provide detailed models for submission to regulatory authorities for permits and compliance checks.`,
        img: "../images/cards/s2b/5.jpg",
      },
    ],
  },
  {
    title: "3D VISUALIZATION",
    iconClass: "icon-phone3",
    description:
      "I create accurate shop drawings using Revit, aligning subcontractors, fabricators, and contractors to realize design concepts, aiding installation and fabrication per project standards.",
    details:
      "My shop drawing services ensure precise detailing based on Construction Documents (CD) following project standards. I employ Revit to create comprehensive shop drawings, aiding on-site installation and workshop fabrication. These drawings effectively communicate the visual design to all involved stakeholders. Their purpose is to align subcontractors, fabricators, and general contractors to collectively realize the design concept by assembling components and facilitating fabrication",
    cards: [
      {
        name: "ARCHITECTURAL SHOP DRAWING",
        content:
          "Help the to architects create distinctive and structurally sound architectural plans for the building's components.",
        img: "../images/cards/3d-visualization/1.jpg",
      },
      {
        name: "STRUCTURAL SHOP DRAWING",
        content:
          "It embodies the most intricate aspects of technical specifications and design purpose for the structural strength of the building, focusing on the smallest details of the concrete reinforcing bars.",
        img: "../images/cards/3d-visualization/2.jpg",
      },
      {
        name: "3D Architectural Rendering",
        content: `
        Our 3D architectural rendering services create photorealistic images of building exteriors and landscapes.
        Realistic exterior views of residential, commercial, and industrial buildings.
        Inclusion of environmental elements like landscaping, lighting, shadows, and weather effects.
        Support for all architectural styles, from traditional to contemporary.
        Detailed facade views, materials, textures, and finishes.`,
        img: "../images/cards/3d-visualization/3.png",
      },
      {
        name: "Animation & Walkthrough",
        content: `We create dynamic animations and walkthroughs that allow clients to explore their designs virtually.
        3D walkthroughs showcasing room-by-room navigation. Smooth fly-through animations of building exteriors and interiors.
        Animated sequences of day-night lighting effects.
        Integration of real-life surroundings and environments for context.`,
        img: "../images/cards/3d-visualization/4.jpg",
      },
      {
        name: "Virtual Reality Visualization",
        content: `Our VR visualization services offer immersive experiences that let clients interact with their designs.
        Virtual tours of properties using VR-compatible models.
        Interactive 3D spaces for real-time design exploration.
        VR integrations for mobile and desktop platforms.
        Support for headsets like Oculus Rift and HTC Vive.`,
        img: "../images/cards/3d-visualization/5.jpg",
      },
    ],
  },
  {
    title: "CAD TO BIM",
    iconClass: "icon-layers2",
    description:
      "I expertly convert CAD drawings to precise BIM models with Revit/Navisworks, emphasizing client details to construction standards for collaborative, code-compliant outcomes. Proficient in 2D/3D software.",
    details:
      "I specialize in converting diverse CAD drawings (architectural, structural, MEP) into detailed BIM models using Autodesk's Revit and Navisworks. My expertise involves extracting accurate measurements and design details from reference files to create collaborative BIM models meeting construction standards. I prioritize understanding client-specific building components and detailing the level of detail (LOD) for each element. Proficient in various 2D and 3D software tools like Revit, Navisworks, Archicad, Dynamo Studio, Recap Pro, Lumion, Enscape and more, I ensure precise delivery aligning with codes and specifications. My experience ensures enriched, information-packed models for seamless subsequent procedures.",
    cards: [
      {
        name: "CAD TO BIM",
        content:
          "I can transform the project drawing into a BIM model in Revit if we have access to a 2D CAD (.dwg) file of the design.",
        img: "../images/cards/c2b/1.jpg",
      },
      {
        name: "3D CAD TO BIM",
        content:
          "I’m capable of transforming a 3D CAD file of the project drawing into a Revit BIM model, even if that's what you possess",
        img: "../images/cards/c2b/2.jpg",
      },
      {
        name: "PDF TO BIM",
        content:
          "I can create a Revit BIM model by converting the project drawings into a BIM model if we have a PDF file of the drawings.",
        img: "../images/cards/c2b/3.jpg",
      },
      {
        name: "SKETCH TO BIM",
        content:
          "A hand-drawn project sketch is all that's required for me to transform it into a Revit BIM model.",
        img: "../images/cards/c2b/4.png",
      },
    ],
  },
  {
    title: "RENDERING",
    iconClass: "icon-phone3",
    description:
      "Specializing in swift and cost-effective 3D rendering using Revit, I transform clients' sketches and plans into architectural visualizations with expertise in Lumion and Enscape, catering to specific needs.",
    details:
      "I specialize in efficient architectural 3D rendering services, translating design concepts into realistic visualizations using Revit. My rapid, cost-effective approach creates detailed architectural models and immersive walkthroughs. Serving Owners, Developers, and Architecture Firms, I employ software like Lumion and Enscape. Clients submit sketches, plans, PDFs, or 3D models with material specs for Development or Redevelopment. Adapting to individual needs, we transform these inputs into high-quality visual representations, tailoring our services for precise visualization requirements.",
    cards: [
      {
        name: "3D MODEL",
        content:
          "It embodies the project with the precise dimensions necessary for construction and visual appeal desired by building owners, developers, and architectural firms, akin to works of art.",
        img: "../images/cards/ren/1.jpg",
      },
      {
        name: "EXTERIOR RENDERING",
        content:
          "Displaying the external aspects of the property and its surrounding environment, whether planned for construction during daytime or nighttime, is depicted in highquality, photo-realistic images well ahead of any scheduled building activities.",
        img: "../images/cards/ren/2.jpg",
      },
      {
        name: "INTERIOR RENDERING",
        content:
          "Demonstrating the spatial arrangement, zoning, materials, textures, color schemes, lighting variations, furniture selection, decor preferences, and more, both during the day and night, using high-quality, realistic photographs.",
        img: "../images/cards/ren/3.jpg",
      },
      {
        name: "ANIMATION AND WALKTHROUGH",
        content:
          "Provides a comprehensive tour of the property as though it has been constructed already, presenting the exterior design and the surrounding areas through a meticulous walkthrough of the building.",
        img: "../images/cards/ren/4.jpg",
      },
      {
        name: "ANIMATION AND WALKTHROUGH",
        content:
          "Provides a comprehensive tour of the property as though it has been constructed already, presenting the exterior design and the surrounding areas through a meticulous walkthrough of the building.",
        img: "../images/cards/ren/1.jpg",
      },
    ],
  },
  {
    title: "STRUCTURAL DESIGN",
    iconClass: "icon-layers2",
    description:
      "We deliver Artificial Intelligence (AI), Machine Learning (ML), and Internet of Things (IoT) implemented Digital twins for FM.",
    details:
      "Seismic designing of concrete structure according to IS code, designing of beam, column, footing and slab. Preparation of G.A drawing, detailing of rebar, BBS and schedule",
    cards: [
      // { name: '', content: '' },
    ],
  },
];
export default servicesData;
